import classNames from 'classnames';

import ArrowDownIcon from '../../assets/icons/arrow-down.svg?react';
import { Listbox, Transition } from '@headlessui/react';
import { FC, Fragment } from 'react';
import { FieldError } from 'react-hook-form';

interface Props {
  className?: string;
  error?: FieldError;
  onChange(newValue: number): void;
  options: SelectOption[];
  placeholder?: string;
  value: number | undefined;
}

export interface SelectOption {
  label: string;
  value: number;
}

export const Select: FC<Props> = ({
  className,
  error,
  onChange,
  options,
  placeholder,
  value,
}) => {
  const selectedOption = options.find((option) => option.value === value);

  return (
    <Listbox value={value ?? 0} onChange={onChange}>
      <div className={classNames('relative', className)}>
        <Listbox.Button
          className={classNames('input input--block bg-white text-left', {
            'input--invalid': Boolean(error),
          })}
        >
          <span
            className={classNames('block truncate', {
              'text-brand-1/50': !selectedOption,
            })}
          >
            {selectedOption ? selectedOption.label : placeholder}
          </span>
          <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-[20px]">
            <ArrowDownIcon aria-hidden="true" />
          </span>
        </Listbox.Button>
        <Transition
          as={Fragment}
          enter="transition duration-100 ease-out"
          enterFrom="transform scale-95 opacity-0"
          enterTo="transform scale-100 opacity-100"
          leave="transition duration-75 ease-out"
          leaveFrom="transform scale-100 opacity-100"
          leaveTo="transform scale-95 opacity-0"
        >
          <Listbox.Options className="absolute z-50 mt-[10px] max-h-[300px] w-full overflow-auto rounded-[12px] border border-brand-2 bg-white shadow-lg">
            {options.map((option) => (
              <Listbox.Option
                key={option.value}
                className="relative cursor-pointer select-none p-[20px] hover:bg-brand-6"
                value={option.value}
              >
                {({ selected }) => (
                  <>
                    <span
                      className={classNames('block truncate', {
                        'font-bold': selected,
                      })}
                    >
                      {option.label}
                    </span>
                  </>
                )}
              </Listbox.Option>
            ))}
          </Listbox.Options>
        </Transition>
      </div>
    </Listbox>
  );
};
